import * as React from "react";
import { styled } from "@mui/material";
import { ClusterWithCr } from "../../../solverHooks/useConversationDD";
import clsx from "clsx";
import { PatientColorMap } from "../../../layout/patientColorMap";
import { ShowInChatReasoningButton } from "./showInChatReasoningButton";
import { useState } from "react";
import { GenericButton } from "../../uiControllers/genericButton";

//region [[ Styles ]]

const TriageReasoningBoxView = styled("div")({
  display: "flex",
  flexFlow: "column",
  paddingTop: "45px",
  margin: "5px 15px",
  flex: 1, // Let them grow to match the width in both mobile and desktop
});

const TriageReasoningListTitle = styled("div")({
  display: "flex",
  flexFlow: "row",
  padding: "20px",
  width: "100%",
  fontWeight: 400,
  fontSize: "17px",
  color: PatientColorMap.Primary,
  borderBottom: `1px solid ${PatientColorMap.Default}`,
});

const TriageReasoningCluster = styled("div")({
  display: "flex",
  flexFlow: "row",
  alignItems: "center",
  justifyContent: "space-between",
  margin: "5px 0",
});

const ClusterTittle = styled("span")({
  fontWeight: 700,
  width: "100%",
});

const SuspicionIndexText = styled("div")({
  width: "100%",
  display: "flex",
  flexFlow: "row",
  justifyContent: "space-evenly",
});
//endregion [[ Styles ]]

//region [[ Props ]]

export interface TriageReasoningBoxProps {
  className?: string;
  title: string;
  clusters: ClusterWithCr[];
  desktop?: boolean;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]
const DEFAULT_NUM_OF_ITEMS_TO_SHOW = 3;
export const TriageConditionReasoningList = ({
  ...props
}: TriageReasoningBoxProps) => {
  const [showAll, setShowAll] = useState(false);

  return (
    <TriageReasoningBoxView
      className={clsx("triage-reasoning-list", props.className)}
    >
      <TriageReasoningListTitle>{props.title}</TriageReasoningListTitle>
      {props.clusters
        .slice(
          0,
          !showAll ? DEFAULT_NUM_OF_ITEMS_TO_SHOW : props.clusters.length,
        )
        .map((cluster) => (
          <TriageReasoningCluster id={cluster.id}>
            <ClusterTittle>{cluster.title.name}</ClusterTittle>
            <ShowInChatReasoningButton
              triage
              cluster={cluster}
              isBackgroundSuggestion={false}
            />
            <SuspicionIndexText>
              <span>Suspicion index</span>
              <span>{(cluster.prob * 100).toFixed(0)}%</span>
            </SuspicionIndexText>
          </TriageReasoningCluster>
        ))}
      {props.desktop &&
        props.clusters.length > DEFAULT_NUM_OF_ITEMS_TO_SHOW && (
          <GenericButton
            onClick={() => setShowAll((currentVal) => !currentVal)}
            label={showAll ? "Show Less" : "Show More"}
          />
        )}
    </TriageReasoningBoxView>
  );
};
